export enum EstimationStatus {
  Initial = 'initial',
  Error = 'error',
  Loading = 'loading',
  Success = 'success'
}
